import PortfolioDealsHistoryContainer from 'presentation/containers/modules/portfolio/PortfolioDealsHistoryContainer';
import PortfolioPageLayout from 'presentation/layout/modules/portfolio/PortfolioPageLayout';
import { FC } from 'react';

const PortfolioDealsHistoryPage: FC = () => {
  return (
    <PortfolioPageLayout>
      <PortfolioDealsHistoryContainer />
    </PortfolioPageLayout>
  );
};

export default PortfolioDealsHistoryPage;
